
const dev_api = {
    host : 'http://localhost:7070' ,
    contenPath: '/' ,
}
const prod_api = {
    host : 'http://boss.clcimplant.com/api/' ,
    contenPath: '/' ,
}
module.exports = {
    // api : process.env.NODE_ENV === 'development'  ? dev_api : prod_api ,
    api : prod_api ,
    //文件配置
    file: {
        //上传地址
        // uploadUrl: 'https://upload.qiniup.com',
        uploadUrl: 'https://up-cn-east-2.qiniup.com',
        //上传后的存储地址前缀
        storePrefix: 'http://static.clcimplant.com/',

        //预览地址前缀
        previewPrefix: process.env.NODE_ENV === 'development' ? 'http://static.clcimplant.com/' : 'http://static.clcimplant.com/',
    }
}

